<!--
 * @auth: lidd
 -->
<template>
<span>
  <span class="file-empty" v-if="disabled && !fileList.length">-</span>
  <sy-upload
    v-else
    v-bind="$attrs"
    v-on="$listeners"
    :limit="limit"
    :accept="accept"
    :maxFileSize="maxFileSize"
    :fileList="fileList"
    acceptType="FILE"
    class="sy-accessory-file-upload"
    :class="{'sy-accessory-file-mini': miniMode, 'sy-accessory-file-disabled': disabled}"
    :on-preview="handlePreview"
    :on-success="handleUploadSuccess"
  >
    <template slot="trigger" v-if="!disabled">
      <el-button
        v-if="miniMode"
        :size='size'
        class="font-color-link sy-accessory-file-trigger-sub-btn"
        type="text"
      >{{pageText.uploadFiles}}</el-button>
      <el-button
        v-else
        :size='size'
        class="sy-accessory-file-trigger-btn"
        plain
      >{{pageText.uploadFiles}}</el-button>
    </template>
    <div class="sy-file-upload-tip" slot="tip" v-if="!miniMode && !disabled">
      <el-popover
        placement="bottom-start"
        title=""
        width="320"
        trigger="hover"
        popper-class="sy-accessory-file-tip-popover"
        :open-delay="300"
        :content="tipText">
        <div slot="reference" class="sy-accessory-file-tip-popover-reference">{{tipText}}</div>
      </el-popover>
    </div>
  </sy-upload>
  <FilePreview
    :prop="{
      prewKey: previewExtraParams.prewKey,
      name: previewExtraParams.name || 'name',
      url: previewExtraParams.url || 'filePath'
    }"
    ref="filePreview"
    :previewDownLoad="false"
    :previewExtraParams="previewExtraParams"
    v-bind="$attrs.filePreview"
    @downLoad="downLoadRequest"
  ></FilePreview>
</span>
</template>

<script>
  import FilePreview from '../../business/preview/index.vue'
import SyUpload from '../sy-upload/upload.vue'
import Api from './api'
import { accessorySystemType } from '../../../common/constants'
import Store from '../../../common/catch-state/store'
import Model from './model'
import download from '../../../utils/download'

Store.install(Model)
const variableReplace = window.fe.variableReplace

export default {
  props: {
    pageText: {
      type: Object,
      default: () => {
        return {}
      }
    },
    miniMode: {type: Boolean, default: false},
    limit: {type: Number},
    maxFileSize: {type: String, default: '5MB'},
    accept: {type: String},
    fileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 附件预览参数
    previewExtraParams: {
      type: Object,
      default: () => {
        return {
          fileReviewBusinessCode: '',
          bizCode: '',
          prewKey: '',
          name: '',
          url: ''
        }
      }
    }
  },
  components: {
    SyUpload,
    FilePreview
  },
  computed: {
    disabled () {
      return this.$attrs.disabled || false
    },
    tipText () {
      const str = this.accept ? this.accept.split(',').join('、') : ''
      return variableReplace(this.pageText.fileTipText, {limit: this.limit, maxFileSize: this.maxFileSize, str: str})
    },
    // 上传按钮大小
    size () {
      return this.miniMode ? 'mini' : 'small'
    }
  },
  methods: {
    handleUploadSuccess (res, file, fileList) {
      // fix：新建编辑支持附件预览 接口要求预览key是url，但是新上传的文件没有 所以赋值
      if (!file[this.previewExtraParams.prewKey]) {
        file[this.previewExtraParams.prewKey] = res.content.key
      }
      file.filePath = res.content.filePath
      file.key = res.content.key
      this.$attrs['on-success'] && this.$attrs['on-success'](res, file, fileList)
    },
    async getAccessoryToken () {
      let token = await Store.syAccessory('accessoryToken').getter()
      if (token) {
        this.token = token
      } else {
        let res = await Store.syAccessory('getToken').getter()
        if (res.isOk) {
          this.token = res.content
          Store.syAccessory('accessoryToken').update(token)
        } else {
          this.token = ''
        }
      }
    },
    // 文件下载预览
    async handlePreview (file) {
      if (this.$attrs['on-preview']) {
        this.$attrs['on-preview'](file)
        return
      }

      if (this.previewExtraParams.fileReviewBusinessCode && file[this.previewExtraParams.prewKey]) {
        this.$refs['filePreview'].preview(file, this.fileList.map(v => {
            if (!this.previewExtraParams.name && !v.name) {
              v.name = v.originalName
            } else if (this.previewExtraParams.name && !v[this.previewExtraParams.name]) {
              v[this.previewExtraParams.name] = v.originalName || v.name
            }
            return v
          }))
        return
      }

      this.downLoadRequest(file)
    },
    async downLoadRequest (file) {
      if (!this.token) {
        await this.getAccessoryToken()
      }
      const api = Api.downloadFile
      const params = {
        system: accessorySystemType,
        fileUrl: file.fileUrl || file.filePath
      }
      download(api.type, api.url, params)
    }
  }
}
</script>

<style scoped lang="scss">
.sy-accessory-file-upload {
  // display: inline-block;
  // width: 100%;
}
button.sy-accessory-file-trigger-btn {
  border-color: #D0D0D0;
  border-radius: 16px;
  font-size: 14px;
  color: #707070;
}
.sy-accessory-file-mini {
  .sy-accessory-file-trigger-sub-btn {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }
  ::v-deep .el-upload-list__item {
    font-size: 12px;
  }
}
.sy-accessory-file-disabled {
  ::v-deep .el-upload-list {
    .sy-upload-list__item:first-child {
      margin-top: 0;
    }
  }
  &.sy-accessory-file-mini {
    ::v-deep .el-upload-list {
      .sy-upload-list__item:first-child {
        margin-top: 4px;
      }
    }
  }
  ::v-deep .sy-upload-trigger {
    display: none;
  }
}
.sy-accessory-file-tip-popover-reference {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #c0c4cb;
  font-size: 12px;
  line-height: 17px;
  margin-top: 8px;
}
</style>
<style lang="scss">
.sy-accessory-file-tip-popover {
  padding: 8px;
  padding-left: 13px;
  font-size: 12px;
  line-height: 17px;
  color: #242F57;
}
</style>